<template>
  <div class="px-sm-4">
    <b-card body-class="p-md-1 p-0">
      <b-card-header class="align-items-start flex-sm-row flex-column-reverse">
        <b-card-title class="mt-sm-0 mt-2">
          <b-media class="align-items-center">
            <template #aside>
              <div
                v-if="coverPreview || cover"
                class="bg-dark d-flex justify-content-center align-items-center bg-secondary rounded-avatar"
                style="height: 100px"
              >
                <b-img
                  ref="previewEl"
                  :src="coverPreview || cover || errorImage"
                  :alt="title"
                  width="100px"
                  style="max-height: 100px"
                  rounded
                  class="p-25"
                  @error="setAltImg"
                  fluid
                />
              </div>
              <b-avatar
                ref="previewEl"
                :alt="title"
                size="100px"
                rounded="lg"
                v-else
                class="bg-secondary text-muted rounded-avatar"
              >
              </b-avatar>
            </template>
            <h5 class="mb-1 text-white">
              {{ $route.params.id ? "Edit category" : "Create category" }}
            </h5>
            <div class="d-flex flex-wrap">
              <b-button
                class="gradient-btn ml-50 px-75"
                @click="$refs.refInputEl.click()"
              >
                <input
                  @input="changeCover"
                  ref="refInputEl"
                  type="file"
                  class="d-none"
                  accept="image/*"
                />
                <span class="d-none d-sm-inline">Upload</span>
                <feather-icon icon="EditIcon" class="d-inline d-sm-none" />
              </b-button>
              <b-button
                class="ml-50 px-75"
                @click="remove"
                :disabled="!$route.params.id || !cover"
              >
                <feather-icon icon="TrashIcon" />
              </b-button>
            </div>
          </b-media>
        </b-card-title>

        <b-link :to="{ name: 'categories' }">
          <span>back to the category list </span>
          <feather-icon icon="ChevronRightIcon"
        /></b-link>
      </b-card-header>
      <b-card-body>
        <validation-observer ref="createForm">
          <b-form class="form mt-2" @submit.prevent="createForm">
            <b-row>
              <b-col class="d-flex" lg="4">
                <b-form-group label-for="title" class="w-100" label="Title">
                  <validation-provider
                    #default="{ errors }"
                    name="Title"
                    rules="required"
                  >
                    <b-form-input
                      id="title"
                      v-model="title"
                      name="title"
                      :state="errors.length > 0 ? false : null"
                    />
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col class="d-flex" offset="4" lg="4">
                <b-form-group
                  class="d-flex align-items-center mb-0 ml-auto warning-button"
                >
                  <b-form-checkbox
                    v-model="active"
                    name="active"
                    switch
                    inline
                    :uncheckedValue="0"
                    :value="1"
                  >
                    active
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col class="d-flex" lg="4">
                <b-form-group label-for="symbol" class="w-100" label="Symbol">
                  <validation-provider
                    #default="{ errors }"
                    name="Symbol"
                    rules="min:3"
                  >
                    <b-form-input id="symbol" v-model="symbol" name="symbol" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col class="d-flex" lg="4">
                <b-form-group
                  label-for="starting-balance"
                  class="w-100"
                  label="Starting balance ($)"
                >
                  <b-form-input
                    id="starting-balance"
                    v-model="starting_balance"
                    name="starting-balance"
                    type="number"
                    min="1"
                    step="0.0001"
                  />
                </b-form-group>
              </b-col>

              <b-col class="d-flex" lg="4">
                <b-form-group
                  label-for="parent-id"
                  class="w-100"
                  label="Parent"
                >
                  <select-box
                    v-model="parent_id"
                    label="text"
                    class="w-100"
                    select="id"
                    url="category"
                    searchable
                  />
                </b-form-group>
              </b-col>
              <b-col class="d-flex" lg="4">
                <b-form-group
                  label-for="minimum-trade"
                  class="w-100"
                  label="Minimum trade"
                >
                  <b-form-input
                    id="minimum_trade"
                    v-model="minimum_trade"
                    name="minimum_trade"
                    type="number"
                    min="1"
                  />
                </b-form-group>
              </b-col>
              <b-col class="d-flex" lg="4">
                <validation-provider
                  #default="{ errors }"
                  name="Draw down"
                  class="w-100"
                  rules="max-value:100"
                >
                  <b-form-group label-for="draw-down" label="Draw down (%)">
                    <b-form-input
                      id="draw-down"
                      v-model="draw_down"
                      name="draw-down"
                      type="number"
                      min="1"
                      max="100"
                      step="0.0001"
                      :state="errors.length > 0 ? false : null"
                    />
                  </b-form-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
              <b-col class="d-flex" lg="4">
                <b-form-group
                  label-for="duration"
                  class="w-100"
                  label="Duration (hours)"
                >
                  <b-form-input
                    id="duration"
                    v-model="duration"
                    name="duration"
                    type="number"
                    min="1"
                  />
                </b-form-group>
              </b-col>
              <b-col lg="12" class="d-flex flex-wrap">
                <div class="col-md-4 col-12 pl-0 pr-md-1 pr-0">
                  <b-form-group
                    label-for="max-participant"
                    label="Max participant"
                  >
                    <b-form-input
                      id="max-participant"
                      v-model="max_participant"
                      name="max_participant"
                      type="number"
                      min="1"
                    />
                  </b-form-group>

                  <b-form-group label-for="profit" label="Profit">
                    <b-form-input
                      id="profit"
                      v-model="profit"
                      name="profit"
                      type="number"
                      min="1"
                    />
                  </b-form-group>
                </div>
                <b-form-group
                  label-for="description"
                  class="col-md-8 col-12 pr-0 pl-md-1 pl-0"
                  label="Description"
                >
                  <validation-provider #default="{ errors }" name="Description">
                    <b-form-textarea
                      id="description"
                      v-model="description"
                      name="description"
                      :state="errors.length > 0 ? false : null"
                      rows="4"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <div class="d-flex align-items-center justify-content-end">
              <b-button class="gradient-btn" type="submit"> submit </b-button>
            </div>
          </b-form>
        </validation-observer>
      </b-card-body>
    </b-card>
    <loader :loading="loading" />
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BLink,
  BInputGroup,
  BInputGroupAppend,
  BFormCheckbox,
  BFormTextarea,
  BMedia,
  BAvatar,
  BImg,
} from "bootstrap-vue";
import { required } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import SelectBox from "@core/components/select-box/SelectBox.vue";
import Loader from "@/@core/components/loader/Loader.vue";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BLink,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    Loader,
    SelectBox,
    BFormTextarea,
    BMedia,
    BAvatar,
    BImg,
  },
  data() {
    return {
      title: "",
      symbol: "",
      starting_balance: "",
      parent_id: "",
      minimum_trade: "",
      draw_down: "",
      max_participant: "",
      profit: "",
      description: "",
      duration: "",
      active: 1,
      cover: "",
      coverPreview: "",
      loading: false,
      // validation rules
      required,
    };
  },
  created() {
    if (this.$route.params.id) {
      this.getCategory();
    }
  },

  methods: {
    async remove() {
      this.loading = true;
      if (this.$route.params.id) {
        try {
          await this.$http.delete(
            `panel/categories/${this.$route.params.id}/cover`
          );
          await this.getCategory();
        } catch (err) {}
      } else {
        this.cover = "";
        this.coverPreview = "";
        this.$refs.refInputEl.value = "";
      }
      this.loading = false;
    },
    async changeCover(e) {
      this.loading = true;
      if (this.$route.params.id) {
        try {
          let formData = new FormData();
          formData.append("cover", e.target.files[0]);
          const { data } = await this.$http.post(
            `panel/categories/${this.$route.params.id}/cover?_method=patch`,
            formData
          );
          this.$refs.refInputEl.value = "";
          await this.getCategory();
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Category logo Updated",
              icon: "EditIcon",
              variant: "success",
            },
          });
        } catch (err) {}
      } else {
        this.cover = e.target.files[0];
        this.coverPreview = URL.createObjectURL(this.cover);
      }
      this.loading = false;
    },
    async getCategory() {
      this.loading = true;
      try {
        const { data } = await this.$http.get(
          `/panel/categories/${this.$route.params.id}`
        );
        await Object.keys(data.data).map((item) => {
          if (item == "active") {
            this[item] = data.data[item] ? 1 : 0;
          } else {
            this[item] = data.data[item];
          }
        });
      } catch (err) {}
      this.loading = false;
    },
    createForm() {
      this.$refs.createForm.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          try {
            this.formData = await new FormData();
            let newObject = await {
              title: this.title,
              symbol: this.symbol,
              starting_balance: this.starting_balance,
              parent_id: this.parent_id,
              minimum_trade: this.minimum_trade,
              draw_down: this.draw_down,
              max_participant: this.max_participant,
              profit: this.profit,
              description: this.description,
              duration: this.duration,
              active: this.active,
            };

            (await !this.$route.params.id) && this.cover
              ? (newObject.cover = this.cover)
              : "";
            await Object.keys(newObject).map((item, index) => {
              this.setFormData(newObject[item], index, item);
            });

            if (this.$route.params.id) {
              const { data } = await this.$http.post(
                `panel/categories/${this.$route.params.id}?_method=put`,
                this.formData
              );
              await this.getCategory();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Category Updated",
                  icon: "EditIcon",
                  variant: "success",
                },
              });
            } else {
              const { data } = await this.$http.post(
                "panel/categories",
                this.formData
              );
              this.$router.push({ name: "categories" });
            }
          } catch (err) {}
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style></style>
